<template>
  <div v-loading="isLoading" style="padding: 20px; padding-top: 0;">
    <h1>Current warehouse:</h1>
    <el-select v-model="currentWarehouse" placeholder="Current warehouse" @change="changeWarehouseId">
      <el-option v-for="item in warehousesList" :key="item.id" :label="item.fname" :value="item.id"></el-option>
    </el-select>

    <div v-if="orders.length >= 1">
      <h1>Relevant <el-button type="primary" class="reload" @click="reload" plain>Update</el-button></h1>
      <el-card
        class="box-card"
        v-for="order in orders"
        v-bind:key="order.id"
        style="margin-bottom: 30px;"
      >
        <!-- header -->
        <template slot="header">
          <el-row>
            <el-col :span="12">
              <div>
                <strong>Order #{{ order.id }}</strong>
                <span style="opacity: .5; margin-left: 5px; display: inline-block; font-size: 80%">
                  <i>created {{ order.time_created | moment("from", "now") }}</i>
                </span>
                <span v-if="Number.parseInt(order.status_id) > 4" style="color: #f56c6c"><br><strong>Approved, specification needs to be filled in</strong></span>
              </div>
            </el-col>
            <el-col :span="12" style="text-align: right">
              <el-button type="danger" @click="openOrder(order.id, order)">Process</el-button>
            </el-col>
          </el-row>
        </template>

        <!-- body -->
        <div>
          <el-row>
            <el-col :span="12">
              <div v-for="product in order.products" v-bind:key="product.id">
                <div style="width: 50px; display: inline-block; vertical-align: top">
                  <img :src="product.photo | resize(50) " class="order-product-image" />
                </div>

                <div class="order-product-info">
                  <p>
                    {{ product.name }}
                    <span
                      v-show="product.amount > 1"
                      style="color: orange;"
                    >x {{ product.amount }}qt.</span>
                  </p>
                  <p v-show="product.sku">Article {{ product.sku }}</p>
                  <p>Price: {{ product.price }} AED</p>
                </div>
              </div>
            </el-col>
            <el-col :span="12" class="order-product-meta">
              <p style="color:red" v-show="order.note_to_florist" v-html="order.note_to_florist"></p>

              <p>
                <i class="el-icon-time" style="font-size: 110%"></i>
                Finish {{ order.floristTime | moment("from", "now") }}
              </p>

<!--              <p v-show="order.piggybank">-->
<!--                <i class="el-icon-money" style="font-size: 110%"></i>-->
<!--                {{ order.piggybank }} AED в копилку-->
<!--              </p>-->
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>
    <div v-else>
      <h1>There is no current orders for you :(</h1>
    </div>

    <div v-if="lastOrders.lastOrders >= 1">
      <h1>Recently finished</h1>
    </div>

    <el-drawer :title="orderTitle" :visible.sync="drawer" :append-to-body="false" size="95%">
      <div v-loading="productLoading">
        <h2 style="color:red" v-if="comment" v-html="this.comment"></h2>
        <TheOrderInfo
          :products="products"
          :warehouses="warehouses"
          :orderID="orderID"
          :isLoading="productLoading"
          :loadingWarehouse="loadingWarehouse"
          @updateWarehouse="updateWarehouse"
          @addPosition="addPosition"
          @removePhoto="removePhoto"
          @addPhoto="addPhoto"
        />

        <el-row style="margin: 20px 0; margin-left: -10px; marign-right: -10px;" :gutter="20">
          <el-col :span="12">
            <el-button type="success" plain style="width: 100%" @click="drawer = false">Save</el-button>
          </el-col>
          <el-col :span="12">
            <el-button type="success" style="width: 100%" @click="finishOrder">Ready</el-button>
          </el-col>
        </el-row>

        <TheOrderAddPosition
          :show="innerDrawer"
          :title="innerTitle"
          @closed="innerDrawer = false"
          :guid="innerProductGuid"
          :index="innerProductIndex"
          :orderID="orderID"
          @addedPosition="addedPosition"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import order from '../api/order'
import TheOrderInfo from '@/components/TheOrderInfo'
import TheOrderAddPosition from '@/components/TheOrderAddPosition'

export default {
  components: {
    TheOrderInfo,
    TheOrderAddPosition
  },
  data () {
    return {
      isLoading: true,
      orderID: 0,
      drawer: false,
      innerDrawer: false,
      innerTitle: '',
      productLoading: false,
      products: [],
      warehouses: {},
      orders: [],
      lastOrders: [],
      loadingWarehouse: false,
      innerProductGuid: '',
      innerProductIndex: 0,
      warehousesList: [],
      currentWarehouse: '',
      comment: '',
    }
  },
  computed: {
    orderTitle () {
      return `Processing order #${this.orderID}`
    }
  },
  async mounted () {
    let orders = await order.getOrderByFlorist(localStorage.token)
    this.orders = orders.data.data.orders
    this.currentWarehouse = orders.data.data.warehouse

    let warehouseList = await order.GetWarehouseList()
    this.warehousesList = warehouseList.data.data
    this.isLoading = false
  },
  methods: {
    reload() {
      document.location.reload()
    },
    addPhoto(data) {
      if(this.products[data.index].images === undefined) {
        this.products[data.index].images = [];
      }
      this.products[data.index].images.push(data.image);
    },
    removePhoto(filename) {
      this.products.forEach((item, index) => {
        if(item.images !== undefined) {
          item.images.forEach((image, j) => {
            if(image.name === filename) {
              this.products[index].images.splice(j, 1);
            }
          });
        }
      });
    },
    changeWarehouseId (value) {
      order.setWarehouseId(value)
      window.location.reload()
    },
    addPosition (product, index) {
      this.innerProductGuid = product.guid
      this.innerProductIndex = index
      this.innerDrawer = true
      this.innerTitle = `Add position - Processing of the order #${this.orderID}`
    },
    finishOrder () {
      let html = '<ol>'
      let hasProductWithoutPhoto = false;

      this.products.forEach(product => {
        html += `<li><h3>${product.name}<h3><ol>`
        let total = 0
        let added = false
        product.positions.forEach(position => {
          if (position.added) {
            html += `<li>${position.name} - ${position.amount}</li>`
            total += position.amount * position.price
            added = true
          }
        });

        let noImage = '';
        if(product.is_flower && (product.images === undefined || product.images.length === 0)) {
          noImage += '<p class="danger">Photo was not uploaded!</p>';
          hasProductWithoutPhoto = true;
        }

        if (!added && product.is_flower) {
          html += `</ol>${noImage}<p class="danger">No composition</p></li>`;
        } else {
          html += `</ol>${noImage}<h4>Budget: ${product.price}. Actual: ${total}</h4></li>`;
        }
      })
      html += '</ol>'

      this.$confirm(html, "Finish order?", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "Yes, everything is correct",
        cancelButtonText: "Cancel",
        type: "warning"
      }).then(() => {
        const submitPromise = hasProductWithoutPhoto => {
          return new Promise((resolve, reject) => {
            if (hasProductWithoutPhoto) {
              this.$confirm(
                html,
                "There are bouquets without photos. Are you sure you want to proceed?",
                {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: "Yes",
                  cancelButtonText: "Cancel",
                  type: "warning"
                }
              ).then(() => {
                resolve();
              })
                .catch(e => {
                  console.log(e);
                  reject();
                });
            } else {
              resolve();
            }
          });
        };

        submitPromise(hasProductWithoutPhoto)
          .then(() => {
            this.isLoading = true;
            order
              .addRealization(this.orderID, this.products)
              .then(response => {
                this.isLoading = false;
                console.log(response);
                let index = 0;
                this.orders.forEach((item, i) => {
                  if (item.id == this.orderID) {
                    index = i;
                  }
                });
                this.orders.splice(index, 1);
                this.innerDrawer = false;
                this.drawer = false;
                this.orderID = 0;

                this.$notify({
                  type: "success",
                  message: "Order was successfully finished",
                  title: "Hooray!",
                  position: "bottom-right"
                });
              });
          }).catch(e => console.log(e));
      }).catch(() => {});
    },
    getSummaries (param) {
      // eslint-disable-next-line no-unused-vars
      let { columns, data } = param

      let totalAmount = 0
      let totalPureSum = 0
      let totalSum = 0

      data.forEach((item, index) => {
        if (item.added) {
          totalAmount += parseFloat(item.amount)
          totalPureSum += parseFloat(item.amount) * parseFloat(item.price)
        }
        totalSum += parseFloat(item.amount) * parseFloat(item.price)
      })

      let sumString = `${totalSum} AED`

      if (totalSum != totalPureSum) {
        sumString = `${totalPureSum} AED (${totalSum} AED)`
      }
      return ['', totalAmount + ' qt.', '', sumString]
    },
    openOrder (orderID, item) {
      // Cache order
      // if (orderID == this.orderID) {
      //   this.drawer = true
      //   return
      // }
      this.productLoading = true
      this.drawer = true
      this.orderID = orderID
      this.comment = item.note_to_florist

      order.getOrderSpecification(orderID).then(response => {
        let result = response.data

        if (result.success) {
          this.products = result.data.products
          this.warehouses = result.data.warehouses

          setTimeout(() => {
            this.productLoading = false
          }, 100)
        } else {
          this.productLoading = false
          this.$notify.error({
            title: 'Error',
            message: result.message
          })
        }
      })
    },
    addedPosition () {
      this.innerDrawer = false
      this.productLoading = true
      this.drawer = true

      order.getOrderSpecification(this.orderID).then(response => {
        this.products = response.data.data.products
        this.warehouses = response.data.data.warehouses

        setTimeout(() => {
          this.productLoading = false
        }, 100)
      })
    },
    async productTimerStart (positionId, key) {
      let request = await order.productTimerStart(positionId)
      if (request.data.success) {
        this.products[key].florist_started = true
        this.products[key].florist_time_use = request.data.data
      }
    },
    async productTimerStop (positionId, key) {
      let request = await order.productTimerStop(positionId)
      if (request.data.success) {
        this.products[key].florist_started = false
        this.products[key].florist_time_use = request.data.data
      }
    },
    updateWarehouse () {
      this.loadingWarehouse = true
      setTimeout(() => {
        order.getWarehouseStock(Object.keys(this.warehouses)).then(response => {
          let result = response.data.data

          this.warehouses = result
          this.loadingWarehouse = false
        })
      }, 400)
    },
    changeProductAmount (currenValue, param, productIndex) {
      let { $index, row } = param

      let productName = this.products[productIndex].name
      let positioName = row.name

      if (currenValue === 0) {
        this.$confirm(
          `Remove <b>${positioName}</b> from ${productName}?`,
          'Are we removing something?',
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: 'Remove',
            cancelButtonText: 'Keep',
            type: 'warning'
          }
        )
          .then(() => {
            this.products[productIndex].specification.splice($index, 1)
            // this.$message({
            //   type: "success",
            //   message: "Delete completed"
            // });
          })
          .catch(() => {
            row.amount = 1
          })
      }
    }
  }
}
</script>

<style>
.order-product-info {
  font-size: 90%;
  font-weight: 400;
  color: #525f7f;
  padding-left: 10px;
  width: calc(100% - 50px - 10px);
  display: inline-block;
  vertical-align: top;
}
.order-product-info p {
  margin: 0;
  margin-bottom: 4px;
}
.order-product-image {
  border-radius: 0.375rem;
}
.order-product-meta p {
  margin: 0;
  margin-bottom: 4px;
  font-size: 90%;
  font-weight: 400;
  padding-left: 10px;
  /* width: calc(100% - 50px - 10px); */
  display: block;
}
.el-card__header {
  padding: 9px 10px !important;
  padding-left: 18px !important;
}
.el-drawer__body {
  padding: 20px;
  max-height: 100%;
  overflow: scroll;
}
.el-drawer__header {
  margin-bottom: 10px !important;
}
.el-table .success-row,
.el-table--enable-row-hover .el-table__body tr.success-row:hover > td {
  background: #67c23a !important;
  border-bottom: 1px solid #59b32d !important;
  color: #fff !important;
}
.el-message-box {
  max-height: 100%;
  overflow: scroll !important;
}
</style>
